import React, {useEffect, useState} from "react";
import {OVERDUE_REMINDER, SEND_REMINDER} from "../../../../configs/AppConfig";
import {updatePreferenceData} from "../../../../services/CommonService";
import {toast} from "react-toastify";
import Utils from "../../../../utils";
import {Lang} from "../../../../lang";

function Notification(props) {

    const [envelopeActivity, setEnvelopeActivity] = useState(1);
    const [envelopeCompleted, setEnvelopeCompleted] = useState(1);
    const [envelopeDueDate, setEnvelopeDueDate] = useState(1);
    const [messageReceivedRecipients, setMessageReceivedRecipients] = useState(1);
    const [recipientFirstViewed, setRecipientFirstViewed] = useState(1);
    const [envelopeSend, setEnvelopeSend] = useState(1);
    const [envelopeResend, setEnvelopeResend] = useState(1);
    const [sendReminderOption, setSendReminderOption] = useState(0);
    const [sendReminder, setSendReminder] = useState(1);
    const [overdueReminderOption, setOverdueReminderOption] = useState(0);
    const [overdueReminder, setOverdueReminder] = useState(1);
    const [messageReceivedSender, setMessageReceivedSender] = useState(1);
    const [requestRejected, setRequestRejected] = useState(1);

    useEffect(function () {
        setEnvelopeActivity((props?.preferenceData.sender_envelope_activity) ? parseInt(props?.preferenceData.sender_envelope_activity) : 1);
        setEnvelopeCompleted((props?.preferenceData.sender_envelope_complete) ? parseInt(props?.preferenceData.sender_envelope_complete) : 1);
        setEnvelopeDueDate((props?.preferenceData.sender_envelope_due_date) ? parseInt(props?.preferenceData.sender_envelope_due_date) : 1);
        setMessageReceivedRecipients((props?.preferenceData.sender_message_received) ? parseInt(props?.preferenceData.sender_message_received) : 1);
        setRecipientFirstViewed((props?.preferenceData.sender_recipient_view) ? parseInt(props?.preferenceData.sender_recipient_view) : 1);

        setEnvelopeSend((props?.preferenceData.recipient_envelope_send) ? parseInt(props?.preferenceData.recipient_envelope_send) : 1);
        setEnvelopeResend((props?.preferenceData.recipient_envelope_resend) ? parseInt(props?.preferenceData.recipient_envelope_resend) : 1);
        setSendReminderOption((props?.preferenceData.recipient_send_reminder_type) ? parseInt(props?.preferenceData.recipient_send_reminder_type) : 0);
        setSendReminder((props?.preferenceData.recipient_send_reminder) ? parseInt(props?.preferenceData.recipient_send_reminder) : 1);
        setOverdueReminderOption((props?.preferenceData.recipient_overdue_reminder_type) ? parseInt(props?.preferenceData.recipient_overdue_reminder_type) : 0);
        setOverdueReminder((props?.preferenceData.recipient_overdue_reminder) ? parseInt(props?.preferenceData.recipient_overdue_reminder) : 1);
        setMessageReceivedSender((props?.preferenceData.recipient_message_received) ? parseInt(props?.preferenceData.recipient_message_received) : 1);
        setRequestRejected((props?.preferenceData.recipient_request_rejected) ? parseInt(props?.preferenceData.recipient_request_rejected) : 1);

    }, [props?.preferenceData]);

    const handleNotification = (e, type) => {

        let envelopeActivityValue = envelopeActivity;
        let envelopeCompletedValue = envelopeCompleted;
        let envelopeDueDateValue = envelopeDueDate;
        let messageReceivedRecipientsValue = messageReceivedRecipients;
        let recipientFirstViewedValue = recipientFirstViewed;
        let envelopeSendValue = envelopeSend;
        let envelopeResendValue = envelopeResend;
        let sendReminderOptionValue = sendReminderOption;
        let sendReminderValue = sendReminder;
        let overdueReminderOptionValue = overdueReminderOption;
        let overdueReminderValue = overdueReminder;
        let messageReceivedSenderValue = messageReceivedSender;
        let requestRejectedValue = requestRejected;

        if (type === 'sender_envelope_activity') {
            setEnvelopeActivity((e.target.checked === true) ? 1 : 0);
            envelopeActivityValue = (e.target.checked === true) ? 1 : 0;
        } else if (type === 'sender_envelope_complete') {
            setEnvelopeCompleted((e.target.checked === true) ? 1 : 0);
            envelopeCompletedValue = (e.target.checked === true) ? 1 : 0;
        } else if (type === 'sender_envelope_due_date') {
            setEnvelopeDueDate((e.target.checked === true) ? 1 : 0);
            envelopeDueDateValue = (e.target.checked === true) ? 1 : 0;
        } else if (type === 'sender_message_received') {
            setMessageReceivedRecipients((e.target.checked === true) ? 1 : 0);
            messageReceivedRecipientsValue = (e.target.checked === true) ? 1 : 0;
        } else if (type === 'sender_recipient_view') {
            setRecipientFirstViewed((e.target.checked === true) ? 1 : 0);
            recipientFirstViewedValue = (e.target.checked === true) ? 1 : 0;
        } else if (type === 'recipient_envelope_send') {
            setEnvelopeSend((e.target.checked === true) ? 1 : 0);
            envelopeSendValue = (e.target.checked === true) ? 1 : 0;
        } else if (type === 'recipient_envelope_resend') {
            setEnvelopeResend((e.target.checked === true) ? 1 : 0);
            envelopeResendValue = (e.target.checked === true) ? 1 : 0;
        } else if (type === 'recipient_send_reminder_type') {
            setSendReminderOption(parseInt(e.target.value));
            sendReminderOptionValue = parseInt(e.target.value);
        } else if (type === 'recipient_send_reminder') {
            setSendReminder((e.target.checked === true) ? 1 : 0);
            sendReminderValue = (e.target.checked === true) ? 1 : 0;
        } else if (type === 'recipient_overdue_reminder_type') {
            setOverdueReminderOption(parseInt(e.target.value));
            overdueReminderOptionValue = parseInt(e.target.value);
        } else if (type === 'recipient_overdue_reminder') {
            setOverdueReminder((e.target.checked === true) ? 1 : 0);
            overdueReminderValue = (e.target.checked === true) ? 1 : 0;
        } else if (type === 'recipient_message_received') {
            setMessageReceivedSender((e.target.checked === true) ? 1 : 0);
            messageReceivedSenderValue = (e.target.checked === true) ? 1 : 0;
        } else if (type === 'recipient_request_rejected') {
            setRequestRejected((e.target.checked === true) ? 1 : 0);
            requestRejectedValue = (e.target.checked === true) ? 1 : 0;
        }

        props.setLoading(true);

        let updateList = [
            {slug: 'sender_envelope_activity', value: envelopeActivityValue},
            {slug: 'sender_envelope_complete', value: envelopeCompletedValue},
            {slug: 'sender_envelope_due_date', value: envelopeDueDateValue},
            {slug: 'sender_message_received', value: messageReceivedRecipientsValue},
            {slug: 'sender_recipient_view', value: recipientFirstViewedValue},
            {slug: 'recipient_envelope_send', value: envelopeSendValue},
            {slug: 'recipient_envelope_resend', value: envelopeResendValue},
            {slug: 'recipient_send_reminder_type', value: sendReminderOptionValue},
            {slug: 'recipient_send_reminder', value: sendReminderValue},
            {slug: 'recipient_overdue_reminder_type', value: overdueReminderOptionValue},
            {slug: 'recipient_overdue_reminder', value: overdueReminderValue},
            {slug: 'recipient_message_received', value: messageReceivedSenderValue},
            {slug: 'recipient_request_rejected', value: requestRejectedValue},
        ];

        updatePreferenceData({list: updateList})
            .then(response => {
                props.setLoading(false);
                toast.success(response.data.message);
            })
            .catch(err => {
                props.setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    };

    return (
        <div className="tab-pane setting-tab-pane active" id="Notification-detail" role="tabpanel">

        <div className="setting-card">
      
          {/* =================== SENDER SECTION =================== */}
          <div className="setting-section-title">Notifications to Sender</div>
      
          {/* Each Notification Row */}
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">Sleeves Activity</p>
              {Lang.notification_envelope_activity}
            </div>
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={envelopeActivity}
                  onChange={(e) => handleNotification(e, "sender_envelope_activity")}
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">Sleeves Completed</p>
              Send email when all requests in a contract sleeve are completed.
            </div>
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={envelopeCompleted}
                  onChange={(e) => handleNotification(e, "sender_envelope_complete")}
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">Sleeves Due Date</p>
              Send email to the sender on the sleeve's due date.
            </div>
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={envelopeDueDate}
                  onChange={(e) => handleNotification(e, "sender_envelope_due_date")}
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">Message Received</p>
              Notify sender when a collaborator sends a new message.
            </div>
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={messageReceivedRecipients}
                  onChange={(e) => handleNotification(e, "sender_message_received")}
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">Collaborator First Viewed</p>
              Notify sender when collaborator first views the sleeve.
            </div>
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={recipientFirstViewed}
                  onChange={(e) => handleNotification(e, "sender_recipient_view")}
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
          {/* =================== COLLABORATOR SECTION =================== */}
          <div className="setting-section-title mt-4">Notifications to Collaborators</div>
      
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">Sleeves Sent</p>
              Notify collaborator when a sleeve is sent to them.
            </div>
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={envelopeSend}
                  onChange={(e) => handleNotification(e, "recipient_envelope_send")}
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
          {/* SEND REMINDER */}
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">Send Reminder</p>
              Reminder sent when contract sleeve is almost due.
              <select
                className="setting-select mt-2"
                value={sendReminderOption}
                onChange={(e) =>
                  handleNotification(e, "recipient_send_reminder_type")
                }
              >
                {SEND_REMINDER.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.value}
                  </option>
                ))}
              </select>
            </div>
      
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={sendReminder}
                  onChange={(e) =>
                    handleNotification(e, "recipient_send_reminder")
                  }
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
          {/* OVERDUE REMINDER */}
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">Overdue Reminder</p>
              Send email when a sleeve is overdue.
              <select
                className="setting-select mt-2"
                value={overdueReminderOption}
                onChange={(e) =>
                  handleNotification(e, "recipient_overdue_reminder_type")
                }
              >
                {OVERDUE_REMINDER.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.value}
                  </option>
                ))}
              </select>
            </div>
      
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={overdueReminder}
                  onChange={(e) =>
                    handleNotification(e, "recipient_overdue_reminder")
                  }
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
          {/* MESSAGE RECEIVED FROM SENDER */}
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">
                Message Received from Sender
              </p>
              Notify collaborator when sender sends a new message.
            </div>
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={messageReceivedSender}
                  onChange={(e) => handleNotification(e, "recipient_message_received")}
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
          {/* REQUEST REJECTED */}
          <div className="setting-row">
            <div className="setting-col">
              <p className="setting-label-bold">Request Rejected</p>
              Notify collaborator when a request is rejected.
            </div>
      
            <div className="setting-col-small">
              <label className="setting-switch">
                <input
                  type="checkbox"
                  checked={requestRejected}
                  onChange={(e) => handleNotification(e, "recipient_request_rejected")}
                />
                <span className="setting-slider"></span>
              </label>
            </div>
          </div>
      
        </div>
      </div>
      
    );
}

export default Notification;